import PropTypes from "prop-types";
import Button from "./Button";
import FontAwesome from "../../icon/FontAwesome";

const ButtonCancel = (props) => {
  const { children, icon, ...attribute } = props;
  return (
    <Button color="danger" {...attribute}>
      <FontAwesome fa={icon || "circle-xmark"} /> {children}
    </Button>
  );
};

ButtonCancel.propTypes = {
  children: PropTypes.any,
};

ButtonCancel.defaultProps = {};

export default ButtonCancel;
